import { __decorate, __metadata } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCInfoCardComponent = class UiCInfoCardComponent {
    constructor() { }
    getStats() {
        switch (this.status) {
            case 'PENDING': {
                return 'CASH_OUT.COLLECTION_BILL_MANAGEMENT.BULLETS.PENDING.DETAILS';
            }
            case 'CANCELED': {
                return 'CASH_OUT.COLLECTION_BILL_MANAGEMENT.BULLETS.CANCELED.DETAILS';
            }
            case 'COMPENSATED': {
                return 'CASH_OUT.COLLECTION_BILL_MANAGEMENT.BULLETS.COMPENSATED.DETAILS';
            }
            case 'AVAILABLE': {
                return 'CASH_OUT.COLLECTION_BILL_MANAGEMENT.BULLETS.AVAILABLE.DETAILS';
            }
            case 'IN_VALIDATION': {
                return 'CASH_OUT.COLLECTION_BILL_MANAGEMENT.BULLETS.IN_VALIDATION.DETAILS';
            }
            case 'IN_PROCESS': {
                return 'CASH_OUT.COLLECTION_BILL_MANAGEMENT.BULLETS.IN_PROCESS.DETAILS';
            }
            case 'DRAFT': {
                return 'CASH_OUT.COLLECTION_BILL_MANAGEMENT.BULLETS.DRAFT.DETAILS';
            }
            case 'OVERDUE': {
                return 'CASH_OUT.COLLECTION_BILL_MANAGEMENT.BULLETS.OVERDUE.DETAILS';
            }
            case 'SPLIT_CREATE': {
                return 'SPLIT.AUCTION.MANAGEMENT_PAGE.SUMMARY_CARDS.CREATE.STATUS_TYPE_TOTAL_REGISTERS';
            }
            case 'SPLIT_AVAILABLE_TO_LIBERATION': {
                return 'SPLIT.AUCTION.MANAGEMENT_PAGE.SUMMARY_CARDS.AVAILABLE_TO_LIBERATION.STATUS_TYPE_TOTAL_REGISTERS';
            }
            case 'SPLIT_AVAILABLE': {
                return 'SPLIT.AUCTION.MANAGEMENT_PAGE.SUMMARY_CARDS.AVAILABLE.STATUS_TYPE_TOTAL_REGISTERS';
            }
            case 'SPLIT_PROCESS_COMPLETED': {
                return 'SPLIT.AUCTION.MANAGEMENT_PAGE.SUMMARY_CARDS.PROCESS_COMPLETED.STATUS_TYPE_TOTAL_REGISTERS';
            }
            case 'SPLIT_RECEIVED':
            case 'SPLIT_COMMISSIONS':
            case 'SPLIT_NET':
                return 'SPLIT.FRANCHISOR.MANAGEMENT_PAGE.SUMMARY_CARDS.STATUS_TYPE_TOTAL_REGISTERS';
            default: {
                return '--';
            }
        }
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInfoCardComponent.prototype, "cardIcon", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInfoCardComponent.prototype, "cardInfo", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInfoCardComponent.prototype, "cardTitle", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInfoCardComponent.prototype, "status", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInfoCardComponent.prototype, "cardColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInfoCardComponent.prototype, "subTitleColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInfoCardComponent.prototype, "size", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCInfoCardComponent.prototype, "param", void 0);
UiCInfoCardComponent = __decorate([
    Component({
        selector: 'ui-c-info-card',
        template: "<div class=\"ui-c-info-card\">\n  <div class=\"info-card bg-light-{{ cardColor }} px-6 py-2 m-3 rounded-xl\">\n    <div class=\"d-flex justify-content-start align-items-center\">\n      <ion-icon name=\"{{cardIcon}}\" class=\"font-size-40 mr-2 mb-0 text-{{ cardColor }}\"></ion-icon>\n      <p class=\"m-0 text-{{ cardColor }} font-family-bold font-size-20\">{{ cardTitle | wlpTranslate}}</p>\n    </div>\n    <p class=\"text-{{ cardColor }} font-family-bold font-size-25 pl-2 mb-0 mt-2\">{{ cardInfo | currency: 'BRL' }}</p>\n    <p class=\"text-{{ cardColor }} font-family-bold font-size-16 pl-2  m-0\">{{getStats() | wlpTranslate: param}}</p>\n  </div>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCInfoCardComponent);

let UiCInfoCardModule = class UiCInfoCardModule {
};
UiCInfoCardModule = __decorate([
    NgModule({
        declarations: [UiCInfoCardComponent],
        imports: [
            CommonModule,
            IonicModule,
            UiBsTranslateModule
        ],
        exports: [UiCInfoCardComponent]
    })
], UiCInfoCardModule);

export { UiCInfoCardComponent, UiCInfoCardModule };
//# sourceMappingURL=wlp-ui-c-info-card.js.map
